import useCartCache from '@store/queries/cart/useCart.cache';
import { DEFAULT_CONFIG_VALUES, memoizedCreateCartFlow } from './cartFlowFactory';

export const useCartFlow = () => {
  const cart = useCartCache();

  if (!cart) return DEFAULT_CONFIG_VALUES;

  return memoizedCreateCartFlow({ cart });
};
